import React, { useState, forwardRef } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  icon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  icon,
  className = '',
  id,
  type,
  ...props
}, ref) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
  const isPasswordType = type === 'password';
  const [showPassword, setShowPassword] = useState(false);
  const resolvedType = isPasswordType && showPassword ? 'text' : type;
  return <div className="w-full" data-id="element-4537">
        {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-4538">
            {label}
          </label>}
        <div className="relative" data-id="element-4539">
          {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" data-id="element-4540">
              {icon}
            </div>}
          <input ref={ref} id={inputId} type={resolvedType} className={`
              w-full px-3 py-2 rounded-lg border
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              placeholder-gray-400 dark:placeholder-gray-500
              transition-colors duration-150
              focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent
              disabled:bg-gray-100 disabled:cursor-not-allowed dark:disabled:bg-gray-700
              ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 dark:border-gray-600'}
              ${icon ? 'pl-10' : ''}
              ${isPasswordType ? 'pr-11' : ''}
              ${className}
            `} {...props} data-id="element-4541" />
          {isPasswordType && <button type="button" tabIndex={-1} onClick={() => setShowPassword(prev => !prev)} className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'} data-id="element-4542">
              {showPassword ? <EyeOffIcon className="w-4 h-4" data-id="element-4543" /> : <EyeIcon className="w-4 h-4" data-id="element-4544" />}
            </button>}
        </div>
        {error && <p className="mt-1 text-sm text-red-500" data-id="element-4545">{error}</p>}
        {helperText && !error && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-4546">
            {helperText}
          </p>}
      </div>;
});
Input.displayName = 'Input';